'use client';

import { Typography } from '@mui/material';
import { usePageAction } from '@repo/hooks/usePageAction';
import { SafeLinkWithFallback } from '../../../../../SafeLinkWithFallback';

type Props = {
  reviewLink?: string;
  institution?: {
    id: string;
    name?: string;
  };
};

export const ProductName = ({ reviewLink, institution }: Props) => {
  const readReviewLinkClickEvent = usePageAction({
    actionDestinationUrl: reviewLink,
    actionName: 'nw_review_redirected',
    actionSection: 'banking_cd_institution_card',
    actionType: 'select',
    additionalAttributes: {
      institution_id: institution?.id,
      institution_nm: institution?.name,
    },
  });

  const handleOnClick = () => {
    readReviewLinkClickEvent();
  };

  return (
    <SafeLinkWithFallback href={reviewLink} onClick={handleOnClick}>
      <Typography
        variant="textMediumBold"
        sx={{
          color: 'text.primary',
          fontSize: { xs: '14px', sm: '24px' },
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {institution?.name}
      </Typography>
    </SafeLinkWithFallback>
  );
};
